$(document).ready(function () {
  let slider = $(".latest-product-slider-container .product-slider-main"),
        slider_items = slider.find(".slider--product"),
        margin_right = parseInt(getComputedStyle(document.querySelector(".slider--product")).marginRight);
  
  let items_to_show = {
    desktop: 3,
    tab: 2,
    mobile: 1
  }
  
  
  const checkWindowSize = () => {
    let window_width = $(window).width() ;
    return window_width <= 650  ? 'mobile' : window_width > 650 && window_width <= 1200 ? 'tab' : 'desktop';
  }
  
  let current_screen = checkWindowSize(), current_index = 1;
  let current_items = items_to_show[current_screen] * current_index;
  
  const calculateItemWidth = () => {
  	let slider_item_width = (slider.width() / items_to_show[current_screen]) - margin_right;
  
    //console.log(slider_item_width, margin_right);

    for (let i = 0; i < slider_items.length; i++) {
      slider_items.eq(i).css('width', `${slider_item_width}px`);
    }
  
  }
  
    const calculateCurrent = () => {
	return  (Math.round(slider.scrollLeft() / slider_items.eq(0).width()) / items_to_show[current_screen]) + 1;
  }
  
    let next_button = $(".slider-initiators .slider--next"),
      prev_button =  $(".slider-initiators .slider--prev");
  
  const setSliderScroll = (scroll_position) => {
  	 slider.animate({scrollLeft: scroll_position}, {
        duration: 500,
        complete: function () {
          	current_index = calculateCurrent();
        	slider.removeAttr('style'); 
          	current_items = items_to_show[current_screen] * current_index;
          	setIndicatorText();
          
	      next_button.prop("disabled", false);
          current_items == slider_items.length ? next_button.prop("disabled", true) : null;
          
          prev_button.prop('disabled', false);
          current_items == items_to_show[current_screen] ? prev_button.prop("disabled", true) : null
        }
      })    
  }
  
  
  const setIndicatorText = () => {
  	 $(".slider-indicator .current-items").text(current_items);
  }
  
  

  
  
  $(window).resize(function () {
    current_index = 1;
    slider.scrollLeft(0);
   	current_screen = checkWindowSize();
   
    
    current_items = items_to_show[current_screen] * current_index;
    
    setIndicatorText();
  	calculateItemWidth();
    
    prev_button.prop('disabled', false);
    next_button.prop('disabled', false);
  })
	
  

  
  calculateItemWidth();
 
  
  setIndicatorText();
   
  prev_button.on("click", function () {
    slider.css('overflow-x', 'auto');
    let prev_index = calculateCurrent() - 1;
    
    if ( prev_index > 0) { 
      let scroll_position = slider.scrollLeft() - slider.width();   
      setSliderScroll(scroll_position);
      

    } else{
    	slider.removeAttr('style');
    }
  })
 
  
  next_button.on("click", function () {  
   	slider.css('overflow-x', 'auto');
    
    //let current = (Math.round(slider.scrollLeft() / slider_items.eq(0).width()) / items_to_show[current_screen]) + 1; 
  	let next_index = calculateCurrent() + 1;
          
    if ( next_index <= slider_items.length ){   
      let scroll_position = slider.scrollLeft() + slider.width(); 
      setSliderScroll(scroll_position);
    }else{
    	slider.removeAttr('style');
    }
  })
  

  
 
  
  
})